import { fetchApi } from '../utils/fetchApi'

export const me = () => fetchApi({
  path: '/me',
})
